function getSelector(key) {
	return `input[name='${key}'],select[name='${key}'],textarea[name='${key}']`;
}

export function fillInputsByName(container, values) {
	Object.keys(values).forEach(key => {
		container.querySelectorAll(getSelector(key)).forEach(input => {
			if (
				input.type === 'radio' ||
				input.type === 'checkbox'
			) {
				if (input.value === values[key]) {
					input.checked = true;
				}
			} else {

				input.value = values[key];
			}
		})
	})
}

export function clearInputsByName(container, fields) {
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			if (
				input.type === 'radio' ||
				input.type === 'checkbox'
			) {
				input.checked = false;
			} else {

				input.value = '';
			}
		})
	});
}

export function getInputsByName(container, fields, removeFromKeys = []) {
	const values = {};
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			if (
				input.type !== 'radio' &&
				input.type !== 'checkbox'
			) {
				removeFromKeys.forEach(string => {
					field = field.replace(string, '');
				});
				values[field] = input.value;
			}
		})
		if (!values[field]) {
			// Value not found, keep checking
			const checkedElement = document.querySelector(`input[name="${field}"]:checked`);
			if (checkedElement) {
				removeFromKeys.forEach(string => {
					field = field.replace(string, '');
				});
				values[field] = checkedElement.value;
			}
		}
	});

	return values;
}

export function clearFeedbacksByName(container, fields) {
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			input.classList.remove('is-invalid');

			input.parentElement.querySelectorAll('.invalid-feedback').forEach(feedback => {
				feedback.innerHTML = '';
			})
		})
	});
}
